"use client";
import React, { useEffect, useState, useRef } from "react";
import CryptoJS from "crypto-js";
import { toast } from "react-toastify";
import SliderSP from "../components/slider/SliderSP";
import logo from "../assets/images/logo.png"
import aboutActive1 from "../assets/images/aboutus/aboutActive1.png"
import aboutActive2 from "../assets/images/aboutus/aboutActive2.png"
import aboutActive3 from "../assets/images/aboutus/aboutActive3.png"
import aboutActive4 from "../assets/images/aboutus/aboutActive4.png"
import about1 from "../assets/images/aboutus/about1.png"
import about2 from "../assets/images/aboutus/about2.png"
import about3 from "../assets/images/aboutus/about3.png"
import about4 from "../assets/images/aboutus/about4.png"
import moke1 from "../assets/images/moke/moke1.png"
import moke2 from "../assets/images/moke/moke2.png"
import moke3 from "../assets/images/moke/moke3.png"
import moke4 from "../assets/images/moke/moke4.png"
import playblack from "../assets/images/playblack.png"
import playwhite from "../assets/images/playwhite.png"
import tableboardgames from "../assets/images/tab/tableboardgames.svg"
import allgames from "../assets/images/tab/allgames.svg"
import cardgames from "../assets/images/tab/cardgames.svg"
import casinogames from "../assets/images/tab/casinogames.svg"
import livegames from "../assets/images/tab/livegames.svg"
import star from "../assets/images/star.svg"
import explore from "../assets/images/explore.svg"
import explorehover from "../assets/images/explorehover.svg"
import contact from "../assets/images/contact.png"
import flash from "../assets/images/flash.png"
import loadblack from "../assets/images/loadblack.png"
import load from "../assets/images/load.png"
import contArrow from "../assets/images/contArrow.png"
import mission from "../assets/images/mission.png"
import goal from "../assets/images/goal.png"
import vision from "../assets/images/vision.png"
import contArrowblack from "../assets/images/contArrowblack.png"
import allTab from "../assets/images/allTab.svg"
import mokebg from "../assets/images/playbg.png"
import comingsoon from "../assets/images/comingsoon.svg"
import { Link } from "react-router-dom";
import { scrollToSection } from "../utils/scrollHelpers";
import aviatorImg from "../assets/images/games/aviator.png";
import rouletteImg from "../assets/images/games/roulette.png";
import gocolorImg from "../assets/images/games/gocolor.png";
import windropImg from "../assets/images/games/windrop.png";
export default function Body({ gamesData = {} }) {
  // Config
const LOCAL_GAME_IMAGES = {
  aviator: aviatorImg,
};
const [selectedGame, setSelectedGame] = useState(null);
  useEffect(() => {
    function updateVisibleCount() {
      const width = window.innerWidth;
      let count = 21; // default fallback

      if (width <= 569) {
        count = 22;
      } else if (width >= 570 && width <= 768) {
        count = 21;
      } else if (width >= 767 && width <= 1000) {
        count = 28;
      } else if (width >= 1001 && width <= 1200) {
        count = 30;
      } else if (width >= 1201 && width <= 1400) {
        count = 24;
      } else if (width >= 1401 && width <= 1900) {
        count = 36;
      } else {
        count = 35;
      }

      setVisibleCount(count);
      setInitialVisibleCount(count);
    }

    updateVisibleCount();
    window.addEventListener("resize", updateVisibleCount);
    return () => window.removeEventListener("resize", updateVisibleCount);
  }, []);

  // State

  const [categories, setCategories] = useState([
    { id: "3", gametype: "Live Games" },
    { id: "4", gametype: "Casino Games" },
    { id: "2", gametype: "Card Games" },
    { id: "1", gametype: "Table & Board Games" }
  ]);
  const [selectedFilter, setSelectedFilter] = useState("all");


  // Hydrate from parent prop
useEffect(() => {
  const staticGames = [
    {
      id: 1,
      gamename: "aviator",
      titlename: "Aviator",
      game_type_name: "Live Games",
      game_type: "3",
      status: 1,
      image: aviatorImg,
    },
       {
      id: 1,
      gamename: "roulette",
      titlename: "Roulette",
      game_type_name: "Casino Games",
      game_type: "3",
      status: 1,
      image: rouletteImg,
    },
       {
      id: 1,
      gamename: "gocolor",
      titlename: "gocolor",
      game_type_name: "Casino Games",
      game_type: "3",
      status: 1,
      image: gocolorImg,
    },
       {
      id: 1,
      gamename: "windrop",
      titlename: "windrop",
      game_type_name: "Casino Games",
      game_type: "3",
      status: 1,
      image: windropImg,
    },
  ];

  if (gamesData && Array.isArray(gamesData.data) && gamesData.data.length > 0) {
    setGames(gamesData.data);
  } else {
    setGames(staticGames);
  }
}, [gamesData]);

  // Handle click outside to close filter panel


  const secretKey = "0987654324567897dsfghj45678";

  // Contact Form State
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: ""
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [formErrors, setFormErrors] = useState({});

  // Contact Form Validation
  const validateForm = () => {
    const errors = {};

    if (!formData.name.trim()) {
      errors.name = true;
    }

    if (!formData.email.trim()) {
      errors.email = true;
    } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(formData.email)) {
      errors.email = true;
    }

    if (!formData.message.trim()) {
      errors.message = true;
    }

    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };
const [submitSuccess, setSubmitSuccess] = useState(false);
  // Handle form input changes
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    let processedValue = value;

    if (name === 'name') {
      processedValue = value.replace(/[^a-zA-Z\s]/g, '');
    } else if (name === 'message') {
      if (value.length > 500) {
        processedValue = value.slice(0, 500);
      }
    }

    setFormData(prev => ({
      ...prev,
      [name]: processedValue
    }));

    if (formErrors[name]) {
      setFormErrors(prev => ({
        ...prev,
        [name]: ""
      }));
    }
  };

  const handleInputBlur = (fieldName) => {
    if (formErrors[fieldName]) {
      setFormErrors(prev => ({
        ...prev,
        [fieldName]: false
      }));
    }
  };

//   const handleContactSubmit = async (e) => {
//     e.preventDefault();

//     if (!validateForm()) {
//       return;
//     }

//     setIsSubmitting(true);

//     try {
//       let token = "";
//       if (window.grecaptcha && typeof window.grecaptcha.getResponse === 'function') {
//         token = window.grecaptcha.getResponse();
//         if (!token) {
//           toast.error("Please complete the CAPTCHA");
//           setIsSubmitting(false);
//           return;
//         }
//       }

//       const data = {
//         name: formData.name,
//         email: formData.email,
//         message: formData.message,
//         token: token
//       };

//       const encrypt_data = CryptoJS.AES.encrypt(
//         JSON.stringify(data),
//         secretKey
//       ).toString();

//       const response = await fetch(
//         'https://t2n24w55s4xr7444khehtuy7bu0ptzwb.lambda-url.ap-south-1.on.aws/',
//         {
//           method: 'POST',
//           mode: 'cors',
//           headers: {
//             'Content-Type': 'application/json',
//           },
//           body: JSON.stringify({
//             encrypt_data: encrypt_data,
//           }),
//         }
//       );

//       if (!response.ok) {
//         throw new Error(`HTTP error! status: ${response.status}`);
//       }

//       const result = await response.json();

//   if (result.code === 200) {
//   toast.success(result.response || "Message sent successfully!");
//   setFormData({ name: "", email: "", message: "" });
//   setSubmitSuccess(true);
//   if (window.grecaptcha && typeof window.grecaptcha.reset === 'function') {
//     window.grecaptcha.reset();
//   }
// } else {
//         toast.error(result.response || "Failed to send message");
//       }
//     } catch (error) {
//       console.error("Contact form error:", error);

//       if (error.message.includes('Failed to fetch')) {
//         toast.error("Network error. Please check your connection and try again.");
//       } else if (error.message.includes('HTTP error')) {
//         toast.error("Server error. Please try again later.");
//       } else {
//         toast.error("An error occurred while sending the email. Please try again.");
//       }
//     } finally {
//       setIsSubmitting(false);
//     }
//   };


const handleContactSubmit = async (e) => {
  e.preventDefault();

  if (!validateForm()) {
    return;
  }

  setIsSubmitting(true);

  // Simulate a brief loading feel, then show success
  setTimeout(() => {
    setFormData({ name: "", email: "", message: "" });
    setSubmitSuccess(true);
    setIsSubmitting(false);
  }, 600);
};

// Auto-reset after 3 seconds
useEffect(() => {
  if (submitSuccess) {
    const timer = setTimeout(() => {
      setSubmitSuccess(false);
    }, 4000);
    return () => clearTimeout(timer);
  }
}, [submitSuccess]);

  // Track when sticky element reaches the top
  useEffect(() => {
    const handleScroll = () => {
      if (stickyElementRef.current) {
        const rect = stickyElementRef.current.getBoundingClientRect();
        // Check if element is stuck at the top (allowing small tolerance for rounding)
        const isAtTop = rect.top <= 1 && rect.top >= -1;
        setIsSticky(isAtTop);
      }
    };

    // Use both scroll and resize events
    window.addEventListener('scroll', handleScroll);
    window.addEventListener('resize', handleScroll);

    // Small delay to ensure proper calculation after page load
    const timeoutId = setTimeout(handleScroll, 100);

    return () => {
      window.removeEventListener('scroll', handleScroll);
      window.removeEventListener('resize', handleScroll);
      clearTimeout(timeoutId);
    };
  }, []);



 const getFilteredGames = () => {
    if (selectedFilter === "all") {
      return games;
    }

    // Map filter names to game_type IDs
    const filterTypeMap = {
      live: "3",
      casino: "4",
      card: "2",
      tableandboard: "1"
    };

    const targetType = filterTypeMap[selectedFilter];
    
    return games.filter(game => String(game.game_type) === targetType);
  };

  // Get category display name
  const getCategoryName = (gameType) => {
    const found = categories.find(c => String(c.id) === String(gameType));
    return found ? found.gametype : "Unknown";
  };










  const [activeFilter, setActiveFilter] = useState("ALL GAMES");
  const [games, setGames] = useState([]);
  const [visibleCount, setVisibleCount] = useState(21);
  const [initialVisibleCount, setInitialVisibleCount] = useState(21);
  const [isSticky, setIsSticky] = useState(false);
  const [isFilterOpen, setIsFilterOpen] = useState(false);

  const stickyElementRef = useRef(null);
  const gamesSectionRef = useRef(null);
  const filterPanelRef = useRef(null);
  const filterButtonRef = useRef(null);

  const LOAD_STEP = 5;

  useEffect(() => {
    function updateVisibleCount() {
      const width = window.innerWidth;
      let count = 21; // default fallback

      if (width <= 569) {
        count = 22;
      } else if (width >= 570 && width <= 768) {
        count = 21;
      } else if (width >= 767 && width <= 1000) {
        count = 28;
      } else if (width >= 1001 && width <= 1200) {
        count = 30;
      } else if (width >= 1201 && width <= 1400) {
        count = 24;
      } else if (width >= 1401 && width <= 1900) {
        count = 36;
      } else {
        count = 35;
      }

      setVisibleCount(count);
      setInitialVisibleCount(count);
    }

    updateVisibleCount();
    window.addEventListener("resize", updateVisibleCount);
    return () => window.removeEventListener("resize", updateVisibleCount);
  }, []);

 

  // UI Filters with icons
  const filters = [
    { name: "ALL GAMES", icon: allgames },
    { name: "LIVE GAMES", icon: livegames },
    { name: "CASINO GAMES", icon: casinogames },
    { name: "CARD GAMES", icon: cardgames },
    { name: "TABLE & BOARD", icon: tableboardgames },
  ];

  // Get selected filter display name
  const getSelectedFilterName = () => {
    return activeFilter;
  };

  // Filter logic based on API category
  const filteredGames =
    activeFilter === "ALL GAMES"
      ? games
      : games.filter((game) => {
        switch (activeFilter) {
          case "LIVE GAMES":
            return game.game_type_name === "Live Games";
          case "CASINO GAMES":
            return game.game_type_name === "Casino Games";
          case "CARD GAMES":
            return game.game_type_name === "Card Games";
          case "TABLE & BOARD":
            return game.game_type_name === "Table & Board Games";
          default:
            return true;
        }
      });

  // Sort games: status !== 2 first (alphabetically), then status === 2 last (alphabetically)
  const sortedFilteredGames = [...filteredGames].sort((a, b) => {
    // First, sort by status (active games before coming soon)
    if (a.status !== 2 && b.status === 2) return -1;
    if (a.status === 2 && b.status !== 2) return 1;
    
    // Then sort alphabetically within each group
    return a.titlename.localeCompare(b.titlename);
  });

  // Get visible games based on count
  const visibleGames = sortedFilteredGames.slice(0, visibleCount);
  const allFilteredVisible = visibleCount >= sortedFilteredGames.length;

  useEffect(() => {
    const handleScroll = () => {
      if (stickyElementRef.current) {
        const rect = stickyElementRef.current.getBoundingClientRect();
        // Check if element is stuck at the top (allowing small tolerance for rounding)
        const isAtTop = rect.top <= 1 && rect.top >= -1;
        setIsSticky(isAtTop);
      }
    };

    // Use both scroll and resize events
    window.addEventListener('scroll', handleScroll);
    window.addEventListener('resize', handleScroll);

    // Small delay to ensure proper calculation after page load
    const timeoutId = setTimeout(handleScroll, 100);

    return () => {
      window.removeEventListener('scroll', handleScroll);
      window.removeEventListener('resize', handleScroll);
      clearTimeout(timeoutId);
    };
  }, []);

const handleLoadToggle = () => {
  if (allFilteredVisible) {
    setVisibleCount(initialVisibleCount);
    
    // Scroll to games section
    setTimeout(() => {
      const gamesSection = document.getElementById('games');
      if (gamesSection) {
        gamesSection.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }
    }, 100);
  } else {
    setVisibleCount(sortedFilteredGames.length);
  }
};
  // Toggle filter panel
  const toggleFilterPanel = () => {
    setIsFilterOpen(!isFilterOpen);
  };

  // Handle filter selection
  const handleFilterClick = (filterName) => {
    setActiveFilter(filterName);
    setVisibleCount(initialVisibleCount);
    setIsFilterOpen(false);
  };


  useEffect(() => {
    const handleClickOutside = (event) => {
      if (isFilterOpen &&
        filterPanelRef.current &&
        !filterPanelRef.current.contains(event.target) &&
        filterButtonRef.current &&
        !filterButtonRef.current.contains(event.target)) {
        setIsFilterOpen(false);
      }
    };

    if (isFilterOpen) {
      document.addEventListener('mousedown', handleClickOutside);
      document.addEventListener('touchstart', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('touchstart', handleClickOutside);
    };
  }, [isFilterOpen]);

  // Prevent body scroll when filter is open
  useEffect(() => {
    if (isFilterOpen) {
      document.body.style.overflow = 'hidden';
      document.documentElement.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
      document.documentElement.style.overflow = 'unset';
    }

    return () => {
      document.body.style.overflow = 'unset';
      document.documentElement.style.overflow = 'unset';
    };
  }, [isFilterOpen]);



  return (
    <div className="no-bottom no-top" id="content">
      <div id="top" />

      <section id="home" className="jarallax pt60 no-bottom addBG">

        <div className="container z-1000 mt-5">
          <div className="row align-items-center">
            <div className="col-lg-12">
              <div className="subtitle wow fadeInUp review-container_main">
                <div className="review-container">
                  <div className="avatars">
                    <div className="avatar"><img src="https://i.pravatar.cc/150?img=33" alt="Reviewer 1" /></div>
                    <div className="avatar"><img src="https://i.pravatar.cc/150?img=12" alt="Reviewer 2" /></div>
                    <div className="avatar"><img src="https://i.pravatar.cc/150?img=13" alt="Reviewer 3" /></div>
                    <div className="avatar"><img src="https://i.pravatar.cc/150?img=47" alt="Reviewer 4" /></div>
                  </div>
                  <div className="review-info">
                    <div className="stars"><span className="star">★</span><span className="star">★</span><span className="star">★</span><span className="star">★</span><span className="star">★</span></div>
                    <div className="review-text">Based on 2169 Reviews</div>
                  </div>
                </div>
              </div>

              <div className="review-container_main cont">
                <h2 className="wow fadeInUp textCont" data-wow-delay=".1s">
                  Experience the Future of Online Gaming Where Speed, Skill, and Style Collide
                </h2>
              </div>

              <div className="review-container_main cont">
                <p className="wow fadeInUp textContp" data-wow-delay=".3s">
                  Dive into Turbo, Casino, Live & Table Games one powerful platform crafted for high performance, stunning visuals, and nonstop entertainment.
                </p>
              </div>

              <div className="review-container_main cont Eplore_Games wow fadeInUp textContp" data-wow-delay=".3s">
                <a onClick={() => scrollToSection("games")}>
                  <button className="SPA_button Cont" >
                    <div className="button-content">
                      <div className="icon-wrapper">
                        <img src={explore} alt="" className="explore" />
                      </div>
                      <span>Explore Games</span>
                    </div>
                    <div className="hover-content Blackexp">
                      <div className="icon-wrapper">
                        <img src={explorehover} alt="" className="explore" />
                      </div>
                      <span>Explore Games</span>
                    </div>
                  </button>
                </a>
              </div>



            </div>
          </div>
        </div>
        <div className="sliderMAin">
          <SliderSP />

        </div>
        <div className="extraspacegames_section"></div>
      </section>

      <section id="games" className="games demo_one demo_clearfix">
            <div className="Gamesbtndiv moBhide">
          <div className="Gamesbtn">
            <img className="stargames" src={star} alt="" /> Games
          </div>
        </div>

       <div
        ref={stickyElementRef}
        className={`exampleElementStickyBlue ${isSticky ? 'spassovtoch' : ''}`}
      >
        <div className="container">
          <div className="row">
            <div className="subtitleBrn mb-3">
              <div className="Gamesbtndiv deskhide">
                <div className="Gamesbtn">
                  <img className="stargames" src={star} alt="" /> Games
                </div>
              </div>
              <div
                ref={filterButtonRef}
                className="GamesbtnTAB"
                onClick={toggleFilterPanel}
                style={{ cursor: 'pointer' }}
              >
                <button className="bottombTN2">
                  <div className="bottomTAB2">
                    <img src={allTab} className="allTab" alt="" />
                    <div>{getSelectedFilterName()}</div>
                    <svg
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="none"
                      style={{
                        marginLeft: '8px',
                        transform: isFilterOpen ? 'rotate(180deg)' : 'rotate(0deg)',
                        transition: 'transform 0.3s ease'
                      }}
                    >
                      <path
                        d="M4 6L8 10L12 6"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </div>
                </button>
              </div>
            </div>

            {/* Desktop Filters */}
            <div className="NEWTAB_filters desktopGame">
              {filters.map((filter) => {
                const isActive = activeFilter === filter.name;

                return (
                  <button
                    key={filter.name}
                    onClick={() => {
                      setActiveFilter(filter.name);
                      setVisibleCount(initialVisibleCount);
                    }}
                    className={`${isActive ? "BTNormal spahilight" : "BTNormal"}`}
                  >
                    <div className="insideCOnt">
                      <span className="boXBtn">
                        <img src={filter.icon} className="tabIMG" alt={filter.name} />
                      </span>
                      {filter.name}
                    </div>
                  </button>
                );
              })}
            </div>
          </div>
        </div>
      </div>

      <div className="container">
        <div className="row">
          <div className="col-lg-12 text-center">
            <div className="NEWTAB_container">
              {/* Game Cards */}
              <div className="container">
                <div className="row">
                  <div className="col-lg-12 text-center">
                    <div className="NEWTAB_container">
                      <div id="NEWTAB_gallery" className="NEWTAB_gallery">
                        {visibleGames.map((game) => (
                          <div key={game.id} className="NEWTAB_item">
                            {/* Image */}
<div
  className={game.status === 2 ? "NEWTAB_card cursornotallowd" : "NEWTAB_card"}
  onClick={() => {
    if (game.status !== 2) {
      sessionStorage.setItem('returnToSection', 'games');
      window.location.href = `/games/${game.gamename}`;
    }
  }}
  style={{ cursor: game.status === 2 ? 'not-allowed' : 'pointer' }}
>
  <div className={`de-item s2 ${game.status === 2 ? "comingsoonhover" : ""}`}>
    <div className={`parenteBOx ${game.status === 2 ? "comingsoonActive" : ""}`}>
      {game.status === 2 && (
        <img src={comingsoon} className="comingsoon" alt="Coming Soon" />
      )}
      <img
        className="NEWTAB_img"
        src={LOCAL_GAME_IMAGES[game.gamename] || game.image}
        alt={game.title_name}
      />
      <button className="GameBTnNormal">
        <div className="button-content">
          <div className="icon-wrapper">
            <img src={playwhite} alt="" className="PlaybuttonHover1" />
          </div>
        </div>
      </button>
    </div>
    <div className="ChildBOx">
      <div className="tiTle">{game.titlename}</div>
      <div className="SubtiTle">{game.game_type_name}</div>
    </div>
  </div>
</div>
                          </div>
                        ))}
                      </div>

                      {/* Load More/Less Button */}
                      {sortedFilteredGames.length > initialVisibleCount && (
                        <div className="loadmoareDIV">
                          <button
                            id="NEWTAB_toggleLoad"
                            className="SPA_button ContBTn NEWTAB_loadBtn"
                            aria-controls="NEWTAB_gallery"
                            aria-expanded={allFilteredVisible}
                            onClick={handleLoadToggle}
                          >
                            <div className="button-content">
                              <div className="iconload">
                                <img src={load} alt="" className="contArrow" />
                              </div>
                              <span>{allFilteredVisible ? 'Show Less' : 'Load More'}</span>
                            </div>
                            <div className="hover-content loadless">
                              <div className="iconload">
                                <img src={loadblack} alt="" className="contArrow" />
                              </div>
                              <span>{allFilteredVisible ? 'Show Less' : 'Load More'}</span>
                            </div>
                          </button>
                        </div>
                      )}

                      <div className="extraspacegames"></div>
                    </div>
                  </div>
                </div>
              </div>

              {/* No Games */}
              {sortedFilteredGames.length === 0 && (
                <div className="text-center py-12 text-gray-500">
                  No games found in this category
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      </section>

      {/* Games Section */}

      <section id="about" className="afpPADDIng">
        <div className="container">
          <div className="row">
            <div className="AB_container">

              <div className="AB_about_card wow fadeInLeft" data-wow-delay=".1s">
                <div className="mainABOUT">
                  <div className="AB_header">

                    <div className="AB_title"> <img src={flash} className="flasjH"
                      alt="" />About Us</div>
                  </div>
                  <p className="AB_description">
                    iqplay Gamings is a studio creating innovative, high-quality
                    gambling games powered by our advanced RGS platform and developed in Unity for
                    smooth cross-platform play.
                  </p>
                </div>
              </div>


              <div className="AB_right_section wow fadeInRight" data-wow-delay=".1s">

                <div className="AB_mission_card">
                  <div className="AB_card_icon_wrapper">
                    <img src={mission} alt="" className="aboutIMG" />
                  </div>
                  <h3 className="AB_card_title">Our Mission</h3>
                  <p className="AB_card_text">
                    Our mission is to redefine the gaming experience by delivering innovative and
                    high-quality gambling games to players worldwide.
                  </p>
                </div>


                <div className="AB_cards_grid">
                  <div className="AB_card">
                    <div className="AB_card_icon_wrapper">
                      <img src={vision} alt="" className="aboutIMG" />
                    </div>
                    <h3 className="AB_card_title">Our Vision</h3>
                    <p className="AB_card_text">
                      Our mission is to deliver innovative, high quality gambling games worldwide
                    </p>
                  </div>

                  <div className="AB_card">
                    <div className="AB_card_icon_wrapper">
                      <img src={goal} alt="" className="aboutIMG" />
                    </div>
                    <h3 className="AB_card_title">Our Goal</h3>
                    <p className="AB_card_text">
                      iqplay Gaming strives to be a global leader in excellence, innovation, and customer satisfaction.
                    </p>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>

        <div className="mokBox">

          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="paddingcust  sm-padding40 jarallax position-relative">

                  <div className="row">
                    <div className="col-lg-12">
                      <div className="moke-wrapperMAin">
                        <img
                          src={mokebg}
                          className="mokebg"

                        />
                        <div className="moke-wrapper">

                          <img
                            src={moke1}
                            className="mokeimG slide active mo1"
                            data-tab={0}
                            alt="Mockup 1"
                          />
                          <img
                            src={moke2}
                            className="mokeimG slide mo2"
                            data-tab={1}
                            alt="Mockup 2"
                          />
                          <img
                            src={moke3}
                            className="mokeimG slide mo3"
                            data-tab={2}
                            alt="Mockup 3"
                          />
                          <img
                            src={moke4}
                            className="mokeimG slide mo4"
                            data-tab={3}
                            alt="Mockup 4"
                          />
                        </div>
                      </div>
                      <div className="mokeDIV">
                        <h2 className="wow fadeInUp mokeDIVheading" data-wow-delay=".2s">
                          Play Everywhere One Account, Endless Experiences.
                        </h2>
                        <p className="wow fadeInUp">
                          Play seamlessly on any device with one account enjoy endless
                          gaming fun anytime, anywhere, without limits.
                        </p>
                        <div className="tabPArent" role="tablist" aria-label="Demo tabs">
                          <button
                            className="tabBtn"
                            role="tab"
                            data-tab={0}
                            aria-selected="true"
                          >
                            <img
                              src={about1}
                              className="tabnormal"
                              alt=""
                            />
                            <img
                              src={aboutActive1}
                              className="tabActive"
                              alt=""
                            />
                          </button>
                          <button
                            className="tabBtn"
                            role="tab"
                            data-tab={1}
                            aria-selected="false"
                          >
                            <img
                              src={about2}
                              className="tabnormal"
                              alt=""
                            />
                            <img
                              src={aboutActive2}
                              className="tabActive"
                              alt=""
                            />
                          </button>
                          <button
                            className="tabBtn"
                            role="tab"
                            data-tab={2}
                            aria-selected="false"
                          >
                            <img
                              src={about3}
                              className="tabnormal"
                              alt=""
                            />
                            <img
                              src={aboutActive3}
                              className="tabActive"
                              alt=""
                            />
                          </button>
                          <button
                            className="tabBtn"
                            role="tab"
                            data-tab={3}
                            aria-selected="false"
                          >
                            <img
                              src={about4}
                              className="tabnormal"
                              alt=""
                            />
                            <img
                              src={aboutActive4}
                              className="tabActive"
                              alt=""
                            />
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>

        </div>

      </section>

      <section id="contact" className="custsection">
        <div className="container paddingTop">
          <div className="row">
            <div className="AB_container">
              {/* Left Section: About Us */}
              <div className="AB_about_card wow fadeInUp" data-wow-delay=".2s">
                <div className="mainABOUT">
                  <div className="AB_header">
                    <div className="AB_title ContactUs">
                      <img
                        src={contact}
                        className="aboutus"
                        alt=""
                      />
                      Contact Us
                    </div>
                  </div>
                  <p className="AB_descriptionh1">
                    Share Your Thoughts - We're Ready to Listen
                  </p>
                  <p className="AB_description">
                    Reach out to us with your thoughts or inquiries. We value your
                    feedback and look forward to hearing from you.
                  </p>
                </div>
              </div>

              {/* Right Section - Contact Form */}
              <div className="AB_right_section aboutSEC wow fadeInUp" data-wow-delay=".2s">
{submitSuccess ? (
  <div style={{
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '2.5rem 1.5rem',
    textAlign: 'center',
  }}>
    {/* Animated tick circle */}
    <div style={{
      width: '72px',
      height: '72px',
      borderRadius: '50%',
      background: 'rgba(34, 197, 94, 0.1)',
      border: '2px solid rgba(34, 197, 94, 0.4)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      marginBottom: '1.25rem',
      animation: 'popIn 0.4s cubic-bezier(0.34,1.56,0.64,1) both',
    }}>
      <svg width="30" height="30" viewBox="0 0 30 30" fill="none">
        <polyline
          points="6,15 12,22 24,9"
          stroke="#22c55e"
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
          style={{
            strokeDasharray: 28,
            strokeDashoffset: 0,
            animation: 'drawCheck 0.5s 0.3s ease forwards',
          }}
        />
      </svg>
    </div>

    <h3 style={{ fontSize: '18px', fontWeight: 500, margin: '0 0 8px', color: '#000000' }}>
      Message sent!
    </h3>
    <p style={{ fontSize: '14px', color: '#aaa', lineHeight: 1.6, margin: '0 0 1.75rem', maxWidth: '280px' }}>
      Thanks for reaching out — we'll get back to you shortly.
    </p>

 
  </div>
) : (
  

                <form
                  name="contactForm"
                  id="contact_form"
                  className="position-relative z1000"
                  onSubmit={handleContactSubmit}
                >
                  <div className="row gx-4">
                    <div className="col-lg-6 mb10">
                      <div className="field-set">
                        <span className="d-label">Name</span>
                        <div className="bordertaxt">
                          <input
                            type="text"
                            name="name"
                            id="name"
                            className={`form-control ${formErrors.name ? 'error' : ''}`}
                            placeholder="Your Name"
                            value={formData.name}
                            onChange={handleInputChange}
                            onBlur={() => handleInputBlur('name')}
                            style={{ borderColor: formErrors.name ? 'red' : '' }}
                          />
                          {formErrors.name && (
                            <span className="errorText" >
                              Please enter your name
                            </span>
                          )}
                        </div>

                      </div>
                    </div>

                    <div className="col-lg-6 mb10">
                      <div className="field-set">
                        <span className="d-label">From</span>
                        <div className="bordertaxt">
                          <input
                            type="text"
                            name="email"
                            id="email"
                            className={`form-control ${formErrors.email ? 'error' : ''}`}
                            placeholder="Your Email"
                            value={formData.email}
                            onChange={handleInputChange}
                            onBlur={() => handleInputBlur('email')}
                            style={{ borderColor: formErrors.email ? 'red' : '' }}
                          />
                          {formErrors.email && (
                            <span className="errorText" >
                              Please enter a valid email address
                            </span>
                          )}
                        </div>
                      </div>
                    </div>

                    <div className="col-lg-12 mb10">
                      <div className="field-set mb15">
                        <span className="d-label">Message</span>
                        <div className="bordertaxt">
                          <textarea
                            name="message"
                            id="message"
                            className={`form-control ${formErrors.message ? 'error' : ''}`}
                            placeholder="Your Message"
                            value={formData.message}
                            onChange={handleInputChange}
                            rows="5"
                            onBlur={() => handleInputBlur('message')}
                            style={{ borderColor: formErrors.message ? 'red' : '' }}
                          />
                          {formErrors.message && (
                            <span className="errorText" >
                              Please enter your message
                            </span>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div id="submit" className="mb20">
                    <div className="menu_side_area">
                      <div className="review-container_main contuS">
                        <button
                          type="submit"
                          className="SPA_button submitBTN"
                          disabled={isSubmitting}
                        >
                          <div className="button-content">
                            <div className="icon-wrapper">
                              <img
                                src={contArrow}
                                alt=""
                                className="SubArrow"
                              />
                            </div>
                            <span>{isSubmitting ? 'Sending...' : 'Submit'}</span>
                          </div>
                          <div className="hover-content">
                            <div className="icon-wrapper">
                              <img
                                src={contArrowblack}
                                alt=""
                                className="SubArrowblacK"
                              />
                            </div>
                            <span>{isSubmitting ? 'Sending...' : 'Submit'}</span>
                          </div>
                        </button>
                      </div>
                    </div>
                  </div>
                </form>
                )}
              </div>
            </div>
          </div>
        </div>
      </section>







      <footer>
        <div className="subfooter">

          <img className="logo-main" src={logo} alt="" />
        </div>

        <div className="subfooter">

          <hr className="footerhr" />
        </div>
        <div className="subfooter">
  ©{new Date().getFullYear()} <span className="Lootrix">iqplay.</span>All Rights Reserved
</div>

      </footer>
      {/* Overlay - only visible when filter is open */}
        {/* Mobile Filter Overlay */}
      {isFilterOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 transition-opacity duration-300"
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            zIndex: 1001,
            background: 'rgba(0, 0, 0, 0.5)',
            pointerEvents: 'auto'
          }}
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            setIsFilterOpen(false);
          }}
        />
      )}

      {/* Mobile Filter Panel */}
      <div
        ref={filterPanelRef}
        className={`fixed bottom-0 left-0 right-0 bg-white rounded-t-3xl shadow-2xl transform transition-transform duration-300 ease-out parentbottomTAB`}
        style={{
          maxHeight: '70%',
          zIndex: 1002,
          transform: isFilterOpen ? 'translateY(0)' : 'translateY(100%)',
          pointerEvents: isFilterOpen ? 'auto' : 'none',
        }}
      >
        {/* Filter Header */}
        <div className="filtERheading">
          <div>Filters</div>
        </div>

        {/* Filter Options */}
        <div className="bottomPArent">
          {filters.map((filter) => {
            const isActive = activeFilter === filter.name;

            return (
              <button
                key={filter.name}
                onClick={() => handleFilterClick(filter.name)}
                className={`${isActive ? "bottombTN selectedBottom" : "bottombTN"}`}
              >
                <div className="bottomTAB">
                  <span className="boXBtn">
                    <img src={filter.icon} className="tabIMG" alt={filter.name} />
                  </span>
                  <div>{filter.name}</div>
                </div>
              </button>
            );
          })}
        </div>
      </div>

    </div>
  );
}